const count = (n: number, one: string, many: string) => (n === 1 ? `1 ${one}` : `${n} ${many}`)

/** "3 registrations", "1 check-in", "3 registrations and 1 check-in". */
export function waitingSummary(registrations: number, checkIns: number): string {
  const parts = [
    registrations > 0 ? count(registrations, 'registration', 'registrations') : null,
    checkIns > 0 ? count(checkIns, 'check-in', 'check-ins') : null,
  ].filter(Boolean)
  return parts.join(' and ')
}
